import React from 'react';
import pt from 'prop-types';
import { connect } from 'react-redux';
import {
  StorefrontNavigation,
  mapStateToProps,
  mapDispatchToProps,
} from 'containers/StorefrontNavigation';
import MenuPage from 'components/pages/modals/edit-menu';

class EditMenuModal extends StorefrontNavigation {
  static contextTypes = {
    openModal: pt.func.isRequired,
    closeModal: pt.func.isRequired,
    notifyError: pt.func.isRequired,
    notifyDeleted: pt.func.isRequired,
  };

  state = {
    menu: null,
    loaded: false,
    edited: false,
  };

  async componentDidMount() {
    await super.componentDidMount.call(this);

    const { params } = this.props;
    const { menus = [] } = this.state;
    const menu = menus.find((menu) => menu.id === params.id);

    this.setState({ menu, loaded: true });
  }

  onSave = async (values) => {
    const success = await super.onSaveMenu(values);

    if (success) {
      this.context.closeModal();
    }
  };

  onDelete = (event) => {
    event.preventDefault();

    const { openModal, closeModal } = this.context;
    const { menu } = this.state;

    openModal('ConfirmDelete', {
      title: 'this menu',
      onConfirm: async () => {
        const success = await super.onDeleteMenu(menu.id);

        if (success) {
          closeModal();
        }
      },
    });
  };

  onEdited = (edited) => {
    this.setState({ edited });
  };

  render() {
    const { menu } = this.state;

    return (
      <MenuPage
        {...this.props}
        {...this.state}
        record={menu}
        onEdited={this.onEdited}
        onSave={this.onSave}
        onDelete={this.onDelete}
      />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditMenuModal);
